<script setup lang="ts">
import { computed } from 'vue'

import { useMetricCatalog } from '../composables/useMetricCatalog'

import type { MetricLabelProps } from './metricLabel.types'

import { MetricView } from '@/shared/ui/metric-view'

const props = withDefaults(defineProps<MetricLabelProps>(), {
  size: 16,
  onlyLogo: false,
  onlyText: false,
})

const catalog = useMetricCatalog()
const resolvedColumn = computed(() => {
  if (props.column) return props.column
  const catalogColumn = props.field ? catalog.getColumn(props.field) : null
  if (catalogColumn) return catalogColumn
  return props.field ? { field: props.field, header: catalog.metricLabel(props.field) } : null
})
</script>

<template>
  <MetricView
    :field="field ?? ''"
    :column="resolvedColumn"
    :channel="channel ?? ''"
    :only-logo="onlyLogo"
    :only-text="onlyText"
    :is-attr="isAttr"
    :size="size"
  />
</template>
